module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("主题颜色配置")]), _vm._v(" "), _c('h2', [_vm._v("配置插件")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("暂时只支持配合"), _c('code', [_vm._v("vux-loader")]), _vm._v("使用。")]), _vm._v(" "), _c('p', [_vm._v("注意的是主题文件不能引入其他less文件，只能为简单变量列表。")])]), _vm._v(" "), _c('p', [_vm._v("请配置vux-loader的"), _c('code', [_vm._v("less-theme")]), _vm._v("插件，指定用以覆盖的less文件路径：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'less-theme'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src/styles/theme.less'")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 相对项目根目录路径")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('h2', [_vm._v("可配置颜色")]), _vm._v(" "), _c('p', [_vm._v("源码地址："), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/styles/variable.less"
    }
  }, [_vm._v("https://github.com/airyland/vux/blob/v2/src/styles/variable.less")])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("更多配置需求请通过 issue 提出。")])]), _vm._v(" "), _c('h2', [_vm._v("demo站点的示例配置")]), _vm._v(" "), _c('p', [_vm._v("源代码地址："), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/theme.less"
    }
  }, [_vm._v("https://github.com/airyland/vux/blob/v2/src/theme.less")])]), _vm._v(" "), _c('h2', [_vm._v("内部如何实现的？")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("vux-loader")]), _vm._v(" 在每个 "), _c('code', [_vm._v("less")]), _vm._v(" 文件的编译过程中重写了 "), _c('code', [_vm._v("less-loader")]), _vm._v(" 的变量参数，使其能直接覆盖原来变量。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30cf7f51", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-30cf7f51"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/theme-162.vue
// module id = 2599
// module chunks = 474